import * as yup from 'yup';

export const ProfileSchema = yup.object().shape({
  name: yup.string().required({ tx: 'errors.required' }),
  profileLink: yup.string().required({ tx: 'errors.required' }),
  title: yup.string().required({ tx: 'errors.required' }),
});
